import clsx from 'clsx';
import { useSearchParams } from 'react-router-dom';
import { CreditKarmaLogo, ExperianLogo, Logo, MasterCardLogo } from 'assets/images';
import Divider from 'components/Divider';
import { DividerDirection } from 'components/Divider/Divider';
import Link from 'components/Link';
import { QueryParams } from 'enums/QueryParams';
import { SourceIds } from 'enums/SourceIds';
import { SPARROW_CARD_PATH } from 'utils/constants';
import styles from './Header.module.scss';

interface HeaderProps {
  centeredLogo?: boolean;
}

const CREDIT_KARMA_LOGO_TEXT = 'Recommended by our marketing partners at';

const getPartnerLogo = (sourceId?: string) => {
  switch (sourceId) {
    case SourceIds.CreditKarma:
      return (
        <div className={styles.partnerLogoContainer}>
          <p className={clsx(styles.text, styles.desktopOnly)}>{CREDIT_KARMA_LOGO_TEXT}</p>
          <CreditKarmaLogo className={styles.logo} role="presentation" />
          <span className="sr-only">credit karma logo</span>
        </div>
      );
    case SourceIds.Experian:
      return (
        <div className={styles.partnerLogoContainer}>
          <ExperianLogo className={styles.logo} role="presentation" />
          <span className="sr-only">experian logo</span>
        </div>
      );
    default:
      return null;
  }
};

const Header = ({ centeredLogo }: HeaderProps) => {
  const [searchParams] = useSearchParams();

  const sourceId = searchParams.get(QueryParams.SourceID) || undefined;
  const logo = getPartnerLogo(sourceId);

  return (
    <header className={styles.header} role="banner">
      <div className={clsx(styles.content, { [styles.center]: centeredLogo })}>
        <Link
          href={SPARROW_CARD_PATH}
          className={styles.link}
          target="_blank"
          ariaLabel="SparrowCard website"
        >
          <Logo className={styles.logo} role="presentation" />
        </Link>

        {!centeredLogo && (
          <>
            <div
              className={clsx(styles.dividersContainer, {
                [styles.dividersCentered]: !!logo,
              })}
            >
              <Divider direction={DividerDirection.Vertical} additionalClassName={styles.divider} />
              <MasterCardLogo className={styles.logo} role="presentation" />
              <span className="sr-only">mastercard logo</span>

              {!!logo && (
                <Divider
                  direction={DividerDirection.Vertical}
                  additionalClassName={clsx(styles.divider, styles.mobileOnly)}
                />
              )}
            </div>
            {logo}
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
